// extracted by mini-css-extract-plugin
export default {"title":"E9AL8R1M8rrNyBLaP4wO"};